import * as React from 'react';
import { Route, Switch } from 'react-router';
import FrontPage from 'components/pages/frontpage/FrontPage';
import Loading from 'components/common/Loading';

const LoginPage = React.lazy(() =>
    import(
        /* webpackChunkName: 'login' */ '../components/pages/login/LoginPage'
    )
);

const CompanyPage = React.lazy(() =>
    import(
        /* webpackChunkName: 'companypage' */ '../components/pages/companypage/CompanyPage'
    )
);

const GroupPage = React.lazy(() =>
    import(
        /* webpackChunkName: 'grouppage' */ '../components/pages/grouppage/GroupPage'
    )
);

const CategoryPage = React.lazy(() =>
    import(
        /* webpackChunkName: 'grouppage' */ '../components/pages/categorypage/CategoryPage'
    )
);

const GroupListPage = React.lazy(() =>
    import(
        /* webpackChunkName: 'grouplistpage' */ '../components/pages/grouplistpage/GroupListPage'
    )
);

const SearchPage = React.lazy(() =>
    import(
        /* webpackChunkName: 'grouplistpage' */ '../components/pages/search/SearchPage'
    )
);

const routes = () => (
    <React.Suspense fallback={<Loading fullScreen={true} />}>
        <Switch>
            <Route path="/" component={FrontPage} exact={true} />
            <Route path="/poiminta" component={SearchPage} />
            <Route path="/kirjaudu-sisaan" component={LoginPage} />
            <Route path="/yritys/:id/:tab?" component={CompanyPage} />
            <Route path="/ryhma/:id" component={GroupPage} />
            <Route
                path="/kategoria/:categoryId/:groupId?"
                component={CategoryPage}
            />
            <Route path="/ryhmat/" component={GroupListPage} exact={true} />
        </Switch>
    </React.Suspense>
);

export default routes;
